module.exports = __webpack_public_path__ + "img/foto-s-zanatiy-1.1f099bf5.png";